import React, { useEffect, useState } from 'react';

import { CALL_STATE } from '../../global/enums';
import { Box, Button, CircularProgress } from '@mui/material';
import { LocalPhoneOutlined } from '@mui/icons-material';
import useSession from '../../hooks/useSession';
import Timer from '../../components/Timer';

/*
https://dashboard.ngrok.com/get-started/your-authtoken
ngrok config add-authtoken YOUR_AUTH_TOKEN
ngrok http 8080
*/
const stateLabel = {
  [CALL_STATE.CONNECTING]: 'Connecting...',
  [CALL_STATE.READY]: 'ready',
  [CALL_STATE.ON_CALL]: 'Hang up',
  [CALL_STATE.OFFLINE]: 'Voice Call',
};

interface IVoiceCallDailyProps {
  styles: any;
  roomName: string;
  sipSessionId: string;
  phoneNumber: string;
}

const VoiceCallDaily = ({
  styles,
  roomName,
  sipSessionId,
  phoneNumber,
}: IVoiceCallDailyProps) => {
  const { sipDialout, sipHangup } = useSession();
  const [callState, setCallState] = useState<CALL_STATE>(CALL_STATE.OFFLINE);

  const handleSipCall = async () => {
    console.log('::::startSipCall (phoneNumber):', phoneNumber);
    //callObject.sendAppMessage({ type: 'dial-sip', target: phoneNumber }, '*');
    if (!phoneNumber) return;

    if (callState === CALL_STATE.OFFLINE) {
      setCallState(CALL_STATE.CONNECTING);
      const resp = await sipDialout({
        phone_number: phoneNumber,
        room_name: roomName,
      });
      console.log('::::resp:', resp);

      if (resp?.ok) {
        //setSipSessionId(resp.sessionId);
        setCallState(CALL_STATE.ON_CALL);
      } else {
        setCallState(CALL_STATE.OFFLINE);
      }
      return;
    }

    const resp = await sipHangup({
      session_id: sipSessionId,
      room_name: roomName,
    });
    console.log('::::resp:', resp);

    setCallState(CALL_STATE.OFFLINE);
  };

  useEffect(() => {
    console.log('::::sipSessionId change:', sipSessionId);
    if (!sipSessionId) setCallState(CALL_STATE.OFFLINE);
  }, [sipSessionId]);

  console.log('::::render voiceCallDaily component');

  return (
    <>
      <Button onClick={handleSipCall} sx={styles.callMobile}>
        {callState === CALL_STATE.CONNECTING ? (
          <CircularProgress size={20} sx={{ mr: '0.5rem' }} />
        ) : (
          <LocalPhoneOutlined sx={{ mr: '0.5rem' }} />
        )}
        {stateLabel[callState]}
      </Button>
      <Box color={'#aaa'}>
        {callState === CALL_STATE.ON_CALL && <Timer />}
        <div>{callState}</div>
      </Box>
    </>
  );
};

export default VoiceCallDaily;
